/**
 * @returns {{ key: string, label: string }}
 */
export function item(key, label = null) {
  return {
    key,
    label: label ?? key
  }
}

export const STATUS = {
  Closed: item('Closed'),
  Open: item('Open')
}

export const SOURCE_TYPE = {
  ClientBulkUpdate: item('ClientBulkUpdate', 'Bulk Update'),
  MassUpdate: item('MassUpdate', 'Data Import'),
  Report: item('Report')
}
